import { Tabs } from '@studio/design-system/tabs';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { RootProps } from './types.js';

/** `<Root>` component. */
export const Root = ({ children, className, tab, ...props }: RootProps): ReactElement => (
  <div className={twMerge('h-full bg-base-200', className)} {...props}>
    <Tabs className='h-full' onChange={tab.setValue} value={tab.value}>
      {children}
    </Tabs>
  </div>
);
